import { isGtmEnabled, trackGtmEvent } from '@motionelements/core/src/helpers/gtm.js';

export default {
    methods: {
        trackExperimentImpression(experimentId, variant) {
            if (isGtmEnabled(this)) {
                window.dataLayer.push({
                    experiment_id: experimentId,
                    variation_id: `${experimentId}.${variant}`,
                });

                trackGtmEvent(this, {
                    event: 'experiment_impression',
                });
            }
        },
    },
};
